(function () {
  'use strict';

  var overlay     = document.getElementById('srch-overlay');
  var trigger     = document.getElementById('srch-trigger');
  var input       = document.getElementById('srch-input');
  var backdrop    = document.getElementById('srch-backdrop');
  var closeBtn    = document.getElementById('srch-close');
  var resultsList = document.getElementById('srch-results');
  var hint        = document.getElementById('srch-hint');
  var loadingEl   = document.getElementById('srch-loading');
  var emptyState  = document.getElementById('srch-empty');
  var emptyQ      = document.getElementById('srch-empty-q');

  if (!overlay || !trigger) return;

  var debounceTimer;
  var activeIndex = -1;

  // ── DOM helpers ──

  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden', ''); }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Price ──
  // Shopify Predictive Search returns prices in the store's minor currency unit.
  // For CLP (0 decimal places) the value is the face amount — no division needed.
  var priceFmt = new Intl.NumberFormat('es-CL', {
    style: 'currency', currency: 'CLP',
    minimumFractionDigits: 0, maximumFractionDigits: 0
  });
  function formatPrice(p) { return priceFmt.format(parseInt(p, 10)); }

  // ── Condition badge from product tags ──

  function getConditionBadge(tags) {
    var t = (tags || []).map(function (s) { return s.toLowerCase(); });
    if (t.indexOf('seminuevo') > -1)       return { cls: 'badge-sn', label: 'Seminuevo' };
    if (t.indexOf('reacondicionado') > -1)  return { cls: 'badge-rc', label: 'Reacondicionado' };
    if (t.indexOf('open-box') > -1 || t.indexOf('open box') > -1) return { cls: 'badge-ob', label: 'Open Box' };
    return null;
  }

  // ── State transitions ──

  function showHint()    { hide(loadingEl); hide(resultsList); hide(emptyState); show(hint); }
  function showLoading() { hide(hint); hide(resultsList); hide(emptyState); show(loadingEl); }
  function showResults() { hide(hint); hide(loadingEl); hide(emptyState); show(resultsList); }
  function showEmpty()   { hide(hint); hide(loadingEl); hide(resultsList); show(emptyState); }

  // ── Open / close ──

  function openSearch() {
    overlay.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 30);
  }

  function closeSearch() {
    overlay.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
    if (input) input.value = '';
    document.body.style.overflow = '';
    resultsList.innerHTML = '';
    activeIndex = -1;
    showHint();
  }

  // ── Render ──

  function renderResults(products, query) {
    resultsList.innerHTML = '';
    activeIndex = -1;

    if (!products || !products.length) {
      if (emptyQ) emptyQ.textContent = query;
      showEmpty();
      return;
    }

    products.forEach(function (product) {
      var badge = getConditionBadge(product.tags);

      var imgUrl = '';
      if (product.featured_image && product.featured_image.url) {
        imgUrl = product.featured_image.url.replace(/(\.\w+)(\?|$)/, '_100x100$1$2');
      }

      var imgHtml = imgUrl
        ? '<img class="srch-item-img" src="' + imgUrl + '" alt="' + escapeHtml(product.title) + '" width="48" height="48" loading="lazy">'
        : '<div class="srch-item-img--placeholder"></div>';

      var badgeHtml = badge
        ? '<span class="badge ' + badge.cls + '">' + badge.label + '</span>'
        : '';

      var li = document.createElement('li');
      li.className = 'srch-item';
      li.setAttribute('role', 'option');
      li.innerHTML =
        '<a class="srch-item-link" href="' + product.url + '">' +
          imgHtml +
          '<div class="srch-item-body">' +
            '<span class="srch-item-name">' + escapeHtml(product.title) + '</span>' +
            badgeHtml +
          '</div>' +
          '<span class="srch-item-price">' + formatPrice(product.price) + '</span>' +
        '</a>';
      resultsList.appendChild(li);
    });

    showResults();
  }

  // ── Fetch from Shopify Predictive Search API ──

  function fetchResults(query) {
    showLoading();
    fetch(
      '/search/suggest?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=8',
      { headers: { 'Accept': 'application/json' } }
    )
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var products = (
        data.resources &&
        data.resources.results &&
        data.resources.results.products
      ) || [];
      console.log('[search] query="' + query + '" results=' + products.length);
      renderResults(products, query);
    })
    .catch(function (err) {
      console.warn('[search] API error:', err);
      renderResults([], query);
    });
  }

  // ── Keyboard navigation ──

  function handleArrows(e) {
    var items = resultsList.querySelectorAll('.srch-item-link');
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, items.length - 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, 0);
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      e.preventDefault();
      items[activeIndex].click();
      return;
    } else {
      return;
    }

    items.forEach(function (item, i) {
      var li = item.closest && item.closest('.srch-item');
      if (li) li.classList.toggle('srch-item--active', i === activeIndex);
    });
    if (items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  // ── Event listeners ──

  trigger.addEventListener('click', openSearch);
  if (closeBtn)  closeBtn.addEventListener('click', closeSearch);
  if (backdrop)  backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    // ⌘K / Ctrl+K — open from anywhere
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      overlay.hasAttribute('hidden') ? openSearch() : closeSearch();
      return;
    }
    if (overlay.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { closeSearch(); return; }
    handleArrows(e);
  });

  if (input) {
    input.addEventListener('input', function (e) {
      var query = e.target.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        resultsList.innerHTML = '';
        activeIndex = -1;
        showHint();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 250);
    });
  }

})();
